<template>
  <g class="sound">
    <g
      v-for="(sound, index) in visualizationSounds"
      :key="index"
      :transform="`translate(${sound.positionX} -${sound.positionY})`"
    >
      <use
        x="-2"
        y="-2"
        width="4"
        height="4"
        :xlink:href="`#sound-volum${level(sound.sound)}`"
      />
    </g>
  </g>
</template>

<script>
import config from '@/config.js';

export default {
  computed: {
    spots: ({ $store }) => $store.getters['area/spotAll'],
    visualizationSounds: (vm) => vm.spots.filter((spot) => vm.isOpenSpot(spot)).map((spot) => vm.buildSoundBy(spot)),
    visualizationSoundConfig:() => config.visualizationHeaders['sound'],
    soundMinValue: (vm) => vm.visualizationSoundConfig.minValue,
    soundMaxValue: (vm) => vm.visualizationSoundConfig.maxValue,
    soundColorCount: (vm) => vm.visualizationSoundConfig.colors.length,
    level: (vm) => (value) => vm.calculateSoundLevel(value),
  },
  methods: {
    isNotRestroom(spot) {
      return spot.spotState && spot.type.indexOf('Restroom') < 0;
    },
    isOpenSpot(spot) {
      return spot.spotState && spot.type.indexOf('OpenSpot') >= 0;
    },
    calculateSoundLevel(value) {
      if (this.soundMaxValue <= this.soundMinValue || !Number.isFinite(value)) return 1;

      const normalized = Math.max(0, Math.min(1, (value - this.soundMinValue) / (this.soundMaxValue - this.soundMinValue)));
      const level = Math.round(normalized * (this.soundColorCount - 1)) + 1;
      return level;
    },
    buildSoundBy(spot) {
      return {
        positionX: spot.positionX,
        positionY: spot.positionY,
        sound: spot.spotState.noise || 1,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// sound.vue?9e50131a